var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-plotly',{staticStyle:{"width":"100%","height":"400px"},attrs:{"data":_vm.sunburstData,"layout":_vm.sunburstLayout,"options":{displayModeBar: false}},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }